import { useSelector } from 'react-redux'
import { selectPlaces } from '@/features/domain/place'

export const useHasPlaces = () => {
  const places = useSelector(selectPlaces)

  return Object.keys(places).length > 0
}
